import { environment } from '../../../../../environments/environment';

const loginByTokenPath = '/user/myInfo';

export const RedirectLoginServicePathConst = `${environment.api.apiV1}${loginByTokenPath}`;
